export const authActions = {
  SETUSER: "SETUSER",
  SETSELECTEDUSER: "SETSELECTEDUSER",
  SETORGANISATION: "SETORGANISATION",
  SETBUSINESSUNIT: "SETBUSINESSUNIT",
  SETAPP: "SETAPP",
};

export function setUser(user) {
  return { type: authActions.SETUSER, user };
}

export function setSelectedUser(selectedUser) {
  return { type: authActions.SETSELECTEDUSER, selectedUser };
}

export function setOrganisation(organisation) {
  return { type: authActions.SETORGANISATION, organisation };
}

export function setBusinessUnit(businessUnit) {
  return { type: authActions.SETBUSINESSUNIT, businessUnit };
}

export function setApp(app) {
  return { type: authActions.SETAPP, app };
}
